import type { GameAction } from "../core/types";

/** Tuş → GameAction eşlemesi. */
const KEY_MAP: Record<string, GameAction> = {
  arrowup: "up",
  w: "up",
  arrowdown: "down",
  s: "down",
  arrowleft: "left",
  a: "left",
  arrowright: "right",
  d: "right",
  enter: "ok",
  " ": "ok",
  escape: "back",
  backspace: "back",
  m: "sound",
  p: "pause",
  f: "fullscreen",
};

const SUPPRESS_DEFAULT = new Set([
  "arrowup",
  "arrowdown",
  "arrowleft",
  "arrowright",
  " ",
]);

/**
 * Klavye girişini dinler. Tarayıcının tuş tekrarını (auto-repeat) bastırır.
 * Döndürülen fonksiyon dinleyicileri kaldırır (temizlik için).
 */
export function attachKeyboard(dispatch: (action: GameAction) => void): () => void {
  const held = new Set<string>();

  const onKeyDown = (event: KeyboardEvent) => {
    const key = event.key.toLowerCase();
    if (SUPPRESS_DEFAULT.has(key)) event.preventDefault();
    if (held.has(key)) return; // auto-repeat engeli
    held.add(key);
    const action = KEY_MAP[key];
    if (action) dispatch(action);
  };

  const onKeyUp = (event: KeyboardEvent) => {
    held.delete(event.key.toLowerCase());
  };

  window.addEventListener("keydown", onKeyDown);
  window.addEventListener("keyup", onKeyUp);
  return () => {
    window.removeEventListener("keydown", onKeyDown);
    window.removeEventListener("keyup", onKeyUp);
  };
}
